import React from 'react';
import './InsufficientCreditsModal.css';

interface InsufficientCreditsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onGoToPurchase: () => void;
    requiredCredits: number;
    availableCredits: number;
}

const InsufficientCreditsModal: React.FC<InsufficientCreditsModalProps> = ({
    isOpen,
    onClose,
    onGoToPurchase,
    requiredCredits,
    availableCredits,
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="insufficient-credits-overlay">
            <div className="insufficient-credits-content">
                <h2>Not Enough Credits</h2>
                <p>
                    You don't have enough credits to complete this action.
                </p>
                <p>
                    Credits needed: <strong>{requiredCredits}</strong>
                </p>
                <p>
                    Credits available: <strong>{availableCredits}</strong>
                </p>
                <div className="modal-actions">
                    <button onClick={onGoToPurchase} className="purchase-button">
                        Buy Credits
                    </button>
                    <button onClick={onClose} className="close-button">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InsufficientCreditsModal;
